module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('bankaccountdialog', {
    ref: "openDialog"
  })], 1), _vm._v(" "), _c('bankDetailList', {
    on: {
      "delete-message": _vm.deleteMessage,
      "edit-account": _vm.editBank
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a25e142"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/account/BankDetail.vue
// module id = 2206
// module chunks = 0